// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ne-6";
export var imgContainer = "_ne-3";
export var menuIcon = "_ne-5";
export var pillWrapper = "_ne-2";
export var pillsContainer = "_ne-1";
export var subscriptionCard = "_ne-0";
export var subscriptionLogo = "_ne-4";